import { c as i, cB as t, cM as o, cE as n } from "./ghl-ui.es384.js";
const p = i([t("notification-container", `
 z-index: 4000;
 position: fixed;
 overflow: visible;
 display: flex;
 flex-direction: column;
 align-items: flex-end;
 `, [i(">", [t("scrollbar", `
 width: initial;
 overflow: visible;
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [i(">", [t("scrollbar-container", `
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [t("scrollbar-content", `
 padding-top: 12px;
 padding-bottom: 33px;
 `)])])])]), o("top, top-right, top-left", `
 top: 12px;
 `, [i("&.transitioning >", [t("scrollbar", [i(">", [t("scrollbar-container", `
 min-height: 100vh !important;
 `)])])])]), o("bottom, bottom-right, bottom-left", `
 bottom: 12px;
 `, [i(">", [t("scrollbar", [i(">", [t("scrollbar-container", [t("scrollbar-content", `
 padding-bottom: 12px;
 `)])])])]), t("notification-wrapper", `
 display: flex;
 align-items: flex-end;
 margin-bottom: 0;
 margin-top: 12px;
 `)]), o("top, bottom", `
 left: 50%;
 transform: translateX(-50%);
 `, [t("notification-wrapper", [i("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: scale(0.85);
 `), i("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: scale(1);
 `)])]), o("top", [t("notification-wrapper", `
 transform-origin: top center;
 `)]), o("bottom", [t("notification-wrapper", `
 transform-origin: bottom center;
 `)]), o("top-right, bottom-right", [t("notification", `
 margin-left: 28px;
 margin-right: 16px;
 `)]), o("top-left, bottom-left", [t("notification", `
 margin-left: 16px;
 margin-right: 28px;
 `)]), o("top-right", `
 right: 0;
 `, [r("top-right")]), o("top-left", `
 left: 0;
 `, [r("top-left")]), o("bottom-right", `
 right: 0;
 `, [r("bottom-right")]), o("bottom-left", `
 left: 0;
 `, [r("bottom-left")]), o("scrollable", [o("top-right", `
 top: 0;
 `), o("top-left", `
 top: 0;
 `), o("bottom-right", `
 bottom: 0;
 `), o("bottom-left", `
 bottom: 0;
 `)]), t("notification-wrapper", `
 margin-bottom: 12px;
 `, [i("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 opacity: 0;
 margin-top: 0 !important;
 margin-bottom: 0 !important;
 `), i("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 opacity: 1;
 `), i("&.notification-transition-leave-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-in),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `), i("&.notification-transition-enter-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-out),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `)]), t("notification", `
 background-color: var(--n-color);
 color: var(--n-text-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 font-family: inherit;
 font-size: var(--n-font-size);
 font-weight: 400;
 position: relative;
 display: flex;
 overflow: hidden;
 flex-shrink: 0;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 width: var(--n-width);
 max-width: calc(100vw - 16px - 16px);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 box-sizing: border-box;
 opacity: 1;
 `, [n("avatar", [t("icon", `
 color: var(--n-icon-color);
 `), t("base-icon", `
 color: var(--n-icon-color);
 `)]), o("show-avatar", [t("notification-main", `
 margin-left: 40px;
 width: calc(100% - 40px); 
 `)]), o("closable", [t("notification-main", [i("> *:first-child", `
 padding-right: 20px;
 `)]), n("close", `
 position: absolute;
 top: 0;
 right: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), n("avatar", `
 position: absolute;
 top: var(--n-padding-top);
 left: var(--n-padding-left);
 width: 28px;
 height: 28px;
 font-size: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [t("icon", "transition: color .3s var(--n-bezier);")]), t("notification-main", `
 padding-top: var(--n-padding-top);
 padding-bottom: var(--n-padding-bottom);
 box-sizing: border-box;
 display: flex;
 flex-direction: column;
 margin-left: 8px;
 width: calc(100% - 8px);
 `, [t("notification-main-footer", `
 display: flex;
 align-items: center;
 justify-content: space-between;
 margin-top: 12px;
 `, [n("meta", `
 font-size: var(--n-meta-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), n("action", `
 cursor: pointer;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-action-text-color);
 `)]), n("header", `
 font-weight: var(--n-title-font-weight);
 font-size: var(--n-title-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-title-text-color);
 `), n("description", `
 margin-top: 8px;
 font-size: var(--n-description-font-size);
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), n("content", `
 line-height: var(--n-line-height);
 margin: 12px 0 0 0;
 font-family: inherit;
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-text-color);
 `, [i("&:first-child", "margin: 0;")])])])])]);
function r(a) {
  const e = a.split("-")[1] === "left" ? "calc(-100%)" : "calc(100%)", c = "0";
  return t("notification-wrapper", [i("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: translate(${e}, 0);
 `), i("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: translate(${c}, 0);
 `)]);
}
export {
  p as default
};
